import { useDispatch, useSelector } from 'react-redux';

import BaseCheckbox from '@r1-frontend/ui-react/components/controls/baseCheckbox';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';

import { toggleConnectAutoPayStatus, toggleSaveCardStatus } from '~/src/features/payments-abn/store/actionCreators';
import { TState } from '~/src/store';

export const SaveNewCard = (): JSX.Element => {
    const {
        auth: { isAuth },
        payment: {
            isSaveCard,
        },
    } = useSelector((state: TState) => state);

    const dispatch = useDispatch();


    const onToggleSaveCard = () => {
        dispatch(toggleSaveCardStatus(!isSaveCard));
        dispatch(toggleConnectAutoPayStatus(!isSaveCard));
    };

    return (
        <ListContainer $size={12} $direction='column'>
            <Paragraph4>Данные карты нужно будет ввести после нажатия на&nbsp;кнопку «Оплатить»</Paragraph4>
            {isAuth && (
                <BaseCheckbox
                    size={'XS'}
                    checked={isSaveCard}
                    onChange={onToggleSaveCard}
                >
                    Сохранить карту после оплаты
                </BaseCheckbox>
            )}
        </ListContainer>
    );
};
